export { default as CourseSupportingContent } from './CourseSupportingContent';
